import React from 'react';

const MembershipIcon = ({ fill = "currentColor", width = "24", height = "24" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M2 8.5H22M6 16.5H8M10.5 16.5H14.5M5.2 20.5H18.8C19.9201 20.5 20.4802 20.5 20.908 20.282C21.2843 20.0903 21.5903 19.7843 21.782 19.408C22 18.9802 22 18.4201 22 17.3V6.7C22 5.5799 22 5.01984 21.782 4.59202C21.5903 4.21569 21.2843 3.90973 20.908 3.71799C20.4802 3.5 19.9201 3.5 18.8 3.5H5.2C4.0799 3.5 3.51984 3.5 3.09202 3.71799C2.71569 3.90973 2.40973 4.21569 2.21799 4.59202C2 5.01984 2 5.5799 2 6.7V17.3C2 18.4201 2 18.9802 2.21799 19.408C2.40973 19.7843 2.71569 20.0903 3.09202 20.282C3.51984 20.5 4.07989 20.5 5.2 20.5Z" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default MembershipIcon;
